import React, { useState } from 'react';
import { CTAButton } from './CTAButton';
export const PricingSection: React.FC = () => {
  const [selected, setSelected] = useState<'mega' | 'master'>('master');
  const plans = {
    mega: {
      href: 'https://pagos.indigo33.shop/cart/64298470146417:1',
      label: '→ QUIERO MI MEGA PACK'
    },
    master: {
      href: 'https://pagos.indigo33.shop/cart/64298471227761:1',
      label: '→ QUIERO EL MASTER-PRO 360'
    }
  };
  return <section id="precio" className="bg-[#1A1A1A] py-10 px-4 text-center" data-id="element-188" data-mp="1ncn3dutyv0es">
      <h2 className="text-[clamp(20px,3.5vw,32px)] text-white mb-1 font-black" data-id="element-189" data-mp="1s82dcbousc5x">
        ELEGÍ TU <span className="text-green-brand" data-id="element-190" data-mp="1xa1erg118z08">MEGA PACK</span>
      </h2>
      <p className="text-[13px] text-[#999] font-sans mb-5" data-id="element-191" data-mp="228colqrbv9ig">
        Seleccioná el plan que mejor se adapte a tu proyecto
      </p>

      <div className="grid grid-cols-1 gap-3 max-w-[550px] mx-auto" data-id="element-192" data-mp="2w0fiu1km9zm">
        {/* Option 1: MEGA PACK */}
        <button type="button" onClick={() => setSelected('mega')} className={`relative rounded-xl py-5 px-4 text-left transition-all duration-300 cursor-pointer border-2 ${selected === 'mega' ? 'border-green-brand bg-[#1e2e1e]' : 'border-[#333] bg-[#222] hover:border-[#444]'}`} data-id="element-193" data-mp="7ubqj83lqqjf">
          <div className="flex items-center gap-3" data-id="element-194" data-mp="1cosha23i9nh6">
            <div className="flex-shrink-0" data-id="element-195" data-mp="17stl3sbxr167">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${selected === 'mega' ? 'border-green-brand' : 'border-[#555]'}`} data-id="element-196" data-mp="17ppbgffpbd85">
                {selected === 'mega' && <div className="w-2.5 h-2.5 rounded-full bg-green-brand" data-id="element-197" data-mp="1vgtkfgnbbzwe" />}
              </div>
            </div>
            <div className="flex-1 min-w-0" data-id="element-198" data-mp="1rezotmrz5m33">
              <div className="text-xl leading-none mb-1" data-id="element-199" data-mp="k27nkuzk4zag">🌿</div>
              <h3 className="text-[15px] text-white font-sans font-bold leading-tight" data-id="element-200" data-mp="k3r2ah5kf2a4">
                MEGA PACK TIERRA VIVA
              </h3>
              <p className="text-[12px] text-[#999] font-sans mt-0.5" data-id="element-201" data-mp="hi1a9wp1zwh8">
                3 Tomos + 4 Bonos Pro
              </p>
              <p className="text-[12px] text-green-brand font-sans font-semibold mt-1" data-id="element-202" data-mp="mftb5g7oesxk">
                Ideal para: Todo autoconstructor que quiere ir del suelo a la
                llave
              </p>
            </div>
            <div className="text-right flex-shrink-0" data-id="element-203" data-mp="ch3svmbvb6gs">
              <p className="text-[13px] text-[#777] line-through font-sans" data-id="element-204" data-mp="3uw4kehpgo0hs">
                $56.000
              </p>
              <div className={`text-[clamp(24px,5vw,32px)] font-black leading-none ${selected === 'mega' ? 'text-green-brand' : 'text-white'}`} data-id="element-205" data-mp="3j1vdgrcevy9">
                $19.999
              </div>
              <p className="text-[11px] text-[#888] font-sans" data-id="element-206" data-mp="3py31pxvy636u">ARS</p>
            </div>
          </div>
        </button>

        {/* Option 2: MASTER-PRO 360 */}
        <button id="oferta-master" type="button" onClick={() => setSelected('master')} className={`relative rounded-xl py-5 px-4 text-left transition-all duration-300 cursor-pointer border-2 ${selected === 'master' ? 'border-green-brand bg-[#1e2e1e]' : 'border-[#333] bg-[#222] hover:border-[#444]'}`} data-id="element-207" data-mp="3fzx25mxm5955">
          <div className="flex items-center gap-3" data-id="element-208" data-mp="369osqku4fkeh">
            <div className="flex-shrink-0" data-id="element-209" data-mp="31cf5nbu7fktt">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${selected === 'master' ? 'border-green-brand' : 'border-[#555]'}`} data-id="element-210" data-mp="31et0bjkz2v0u">
                {selected === 'master' && <div className="w-2.5 h-2.5 rounded-full bg-green-brand" data-id="element-211" data-mp="3p2sqahagmhed" />}
              </div>
            </div>
            <div className="flex-1 min-w-0" data-id="element-212" data-mp="3l1z1zmt3v0ky">
              <div className="text-xl leading-none mb-1" data-id="element-213" data-mp="2v2k051xn843">🏆</div>
              <h3 className="text-[15px] text-white font-sans font-bold leading-tight" data-id="element-214" data-mp="2vkmvkj3okkz">
                MEGA PACK TIERRA VIVA + SISTEMA CONSTRUCTIVO MASTER-PRO 360
              </h3>
              <span className="inline-block bg-green-brand text-[#1A1A1A] text-[10px] font-black font-sans px-2 py-0.5 rounded mt-1 uppercase tracking-wide" data-id="element-215" data-mp="hxb1wl9rtrpt">
                MÁS ELEGIDO
              </span>
              <div className="text-sm leading-none mt-0.5" data-id="element-216" data-mp="qrphyq24l69z">⭐</div>
              <p className="text-[12px] text-[#999] font-sans mt-1" data-id="element-217" data-mp="vq0mqmdkcqlc">
                Herramientas de un Director de Obra Profesional para que no
                cometa errores que cuestan millones en materiales
                desperdiciados.
              </p>
              <p className="text-[12px] text-green-brand font-sans font-semibold mt-1" data-id="element-218" data-mp="32wgyf6nc88i">
                Ideal para: Construir como un profesional sin desperdiciar
                materiales
              </p>
            </div>
            <div className="text-right flex-shrink-0" data-id="element-219" data-mp="1jfbski9rtb6c">
              <p className="text-[13px] text-[#777] line-through font-sans" data-id="element-220" data-mp="1jetoizgv9snv">
                $89.000
              </p>
              <div className={`text-[clamp(24px,5vw,32px)] font-black leading-none ${selected === 'master' ? 'text-green-brand' : 'text-white'}`} data-id="element-221" data-mp="1ofzit1q6dnzi">
                $29.999
              </div>
              <p className="text-[11px] text-[#888] font-sans" data-id="element-222" data-mp="2z64adlpbyymj">ARS</p>
            </div>
          </div>
        </button>
      </div>

      {/* CTA Button */}
      <div id="comprar" className="max-w-[550px] mx-auto mt-5" data-id="element-223" data-mp="2u6rmcxmq3lid">
        <CTAButton href={plans[selected].href} className="w-full !py-4 !px-6 !text-base" data-id="element-224" data-mp="2q5zdw6lodkn5">
          {plans[selected].label}
        </CTAButton>

        <div className="flex justify-center gap-2 flex-wrap mt-3" data-id="element-225" data-mp="2g79v8blyfw5u">
          <span className="bg-[#2a2a2a] border border-[#444] rounded-md py-1 px-2.5 text-[10px] font-sans text-[#aaa] font-semibold" data-id="element-226" data-mp="2g7rxppz7n6m7">
            💳 Tarjeta
          </span>
          <span className="bg-[#2a2a2a] border border-[#444] rounded-md py-1 px-2.5 text-[10px] font-sans text-[#aaa] font-semibold" data-id="element-227" data-mp="eevhloqg1dv8">
            📱 MercadoPago
          </span>
          <span className="bg-[#2a2a2a] border border-[#444] rounded-md py-1 px-2.5 text-[10px] font-sans text-[#aaa] font-semibold" data-id="element-228" data-mp="23x0o5awi9bd8">
            🏦 Transferencia
          </span>
        </div>
      </div>

      <p className="text-[12px] text-[#666] font-sans mt-4" data-id="element-229" data-mp="1tzw35eeebly0">
        🔒 Pago 100% seguro &nbsp;|&nbsp; ⚡ Acceso en 5 minutos &nbsp;|&nbsp;
        🛡️ Garantía 7 días
      </p>
    </section>;
};